import { z } from "zod";

export const contactSubjects = [
  "General Question",
  "Existing Reservation",
  "RV Sites & Accommodations",
  "Rates",
  "Amenities",
  "Directions",
  "Extended Stay Question",
  "Other",
] as const;

export type ContactSubject = (typeof contactSubjects)[number];

export const stayRelatedSubjects: ContactSubject[] = [
  "RV Sites & Accommodations",
  "Extended Stay Question",
];

export const contactMessageSchema = z.object({
  firstName: z.string().trim().min(1, "Please enter your first name.").max(80),
  lastName: z.string().trim().min(1, "Please enter your last name.").max(80),
  email: z
    .string()
    .trim()
    .min(1, "Please enter your email address.")
    .email("Please enter a valid email address."),
  phone: z.string().trim().max(40).optional().or(z.literal("")),
  subject: z.enum(contactSubjects, {
    required_error: "Please select a subject.",
    invalid_type_error: "Please select a subject.",
  }),
  message: z
    .string()
    .trim()
    .min(10, "Please tell us how we can help.")
    .max(4000, "Please keep your message under 4,000 characters."),
  /** Honeypot */
  companyWebsite: z.string().max(200).optional().or(z.literal("")),
});

export type ContactMessage = z.infer<typeof contactMessageSchema>;

export function createDefaultContactValues(): ContactMessage {
  return {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: undefined as unknown as ContactSubject,
    message: "",
    companyWebsite: "",
  };
}
